<template>
  <div class="layout" :class="classObject" v-resize>
    <navbar v-show="!isLoading"></navbar>
    <sidebar v-show="!isLoading"></sidebar>
    <!-- <overlay :is-loading="isLoadingLight"></overlay> -->

    <div class="content-wrap" id="content-wrap">
      <main id="content" class="content" role="main">
        <vuestic-breadcrumbs v-show="!isLoading" :breadcrumbs="breadcrumbs"/>
        <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <router-view v-show="!isLoading"></router-view>
      </main>
    </div>
    <div class="made-by-footer" v-show="!isLoading">
      ©2018. Made by&nbsp;<a href="https://entonytocco.com" target="_blank">Antonino Tocco</a>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import Navbar from './navbar/Navbar'
  import Sidebar from './sidebar/Sidebar'
  import Overlay from './sidebar/Overlay'
  import Resize from 'directives/ResizeHandler'

  export default {
    name: 'layout',

    components: {
      Navbar,
      Sidebar,
      Overlay
    },
    directives: {
      resize: Resize
    },
    props: {
      fixed: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'isLoading',
        'isLoadingLight'
      ]),
      classObject: function () {
        return {
          'layout-fixed': this.fixed,
          'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
          'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
        }
      },
      breadcrumbs () {
        return this.$store.getters.breadcrumbs(this.$route.name)
      },
    }
  }
</script>

<style lang="scss">
  @import "../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .layout {
    &-fixed {
      .content-wrap {
        padding-right: $layout-padding-right;
        padding-top: $sidebar-top;

        @include media-breakpoint-down(md) {
          padding: $content-mobile-wrap-fixed-layout;
          margin-left: 0;

        }
      }
    }
  }

  .content-wrap {
    margin-left: $content-wrap-ml;
    transition: margin-left 0.3s ease;
    padding-right: $layout-padding-right;
    padding-top: $layout-padding;

    padding-bottom: $content-wrap-pb;

    .pre-loader {
      position: absolute;
      z-index: 1;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);
      // height:100%;
      .pixel-spinner{
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        // height:100%;
      }
    }


    .sidebar-hidden & {
      margin-left: $sidebar-left;
    }

    @include media-breakpoint-down(md) {
      padding: $content-mobile-wrap;
      margin-left: 0;

      .sidebar-hidden & {
        margin-left: 0;
        padding-top: $content-mobile-wrap-sb-top;
      }
    }
  }

  .made-by-footer {
    padding-top:25px;
    position: absolute;
    bottom: 0;
    padding-bottom: $made-by-footer-pb;
    height: calc(#{$layout-padding} + #{$widget-mb});
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue